<div class="lottie">
  <ng-lottie (segmentStart)="onSegmentStart($event)" [options]="lottieOptions" (animationCreated)="onAnimationCreated($event)"></ng-lottie>
</div>
